import { render, staticRenderFns } from "./StartupSearchParent.vue?vue&type=template&id=2a00f09d"
import script from "./StartupSearchParent.vue?vue&type=script&lang=js"
export * from "./StartupSearchParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports